import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from 'react-intl'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import { formatGroupInformation } from '../utils/groupInformation'
import { BookingDetailsSection } from './BookingDetailsSection'
import styles from './GroupDetailsSection.module.css'
import { SidebarItem } from './SidebarItem'

export function GroupDetailsSection() {
  const { formatMessage } = useIntl()
  const isGroupBooking = useBookingDetailsStore(state => state.isGroupBooking)
  const groupName = useBookingDetailsStore(state => state.groupName)
  const groupSize = useBookingDetailsStore(state => state.groupSize)
  const groupInformation = formatGroupInformation(
    { isGroupBooking, groupName, groupSize },
    groupSize => formatMessage({ id: 'booking_details_group_participants' }, { groupSize }),
  )

  if (!groupInformation) {
    return null
  }

  return (
    <BookingDetailsSection isSidebar>
      <SidebarItem.Container className={styles.container}>
        <SidebarItem iconName="Group" label={formatMessage({ id: 'booking_details_group_label' })}>
          <Typography variant="body-m-bold-tight">{groupInformation}</Typography>
        </SidebarItem>
      </SidebarItem.Container>
    </BookingDetailsSection>
  )
}
